import { apiSendToTelegramGoogleDriveFile } from '@/shared/api/google-drive/api'
import { useMutation } from '@tanstack/react-query'

export const useSendGoogleDriveFilteToTelegram = () => {
    return useMutation({
        mutationFn: apiSendToTelegramGoogleDriveFile,
    })
}
